import * as React from 'react';
import type { InjectedIntlProps } from 'react-intl';
import { injectIntl } from 'react-intl';
import { ButtonGroup } from '@atlaskit/button';
import { SpotlightTarget } from '@atlaskit/onboarding';
import { Button } from '@atlassian/help-center-common-component/analytics';
import messages from './messages';
import { Wrapper, PageHeaderWrapper, ButtonContainer, Title, PageHeader } from './styled';
import type { ActionBarWithButtonsStatelessProps } from './types';

export const ActionsContent: React.FC<ActionBarWithButtonsStatelessProps & InjectedIntlProps> = ({
    intl,
    isDirty,
    openCancelPrompt,
    openPublishPrompt,
}) => {
    return (
        <SpotlightTarget name="portal-reordering-action-buttons">
            <ButtonContainer>
                <ButtonGroup>
                    <Button
                        appearance="subtle"
                        className="portal-reordering-cancel-button"
                        onClick={openCancelPrompt}
                        actionSubjectId="cancelPortalsReorder"
                        data-test-id="cancel-portal-reorder-experience-action-bar"
                    >
                        {intl.formatMessage(messages.cancelButtonLabel)}
                    </Button>
                    <Button
                        appearance="primary"
                        isDisabled={!isDirty}
                        onClick={openPublishPrompt}
                        actionSubjectId="publishPortalsReorder"
                        data-test-id="publish-portal-reorder-experience-action-bar"
                    >
                        {intl.formatMessage(messages.publishButtonLabel)}
                    </Button>
                </ButtonGroup>
            </ButtonContainer>
        </SpotlightTarget>
    );
};

export class ActionBarWithButtonsStateless extends React.Component<
    ActionBarWithButtonsStatelessProps & InjectedIntlProps
> {
    render() {
        const { intl, children } = this.props;

        return (
            <Wrapper>
                <PageHeaderWrapper>
                    <PageHeader>
                        <Title>{intl.formatMessage(messages.actionBarTitle)}</Title>
                        <ActionsContent {...this.props} />
                    </PageHeader>
                    {children}
                </PageHeaderWrapper>
            </Wrapper>
        );
    }
}
export default injectIntl(ActionBarWithButtonsStateless);
